import React, { useRef, useState } from 'react';
import { Form } from 'react-bootstrap';

const ChatInput = ({
  disabled,
  onSend,
  projects = [],
  projectId,
  onProjectChange,
  placeholder = 'Ask a question',
}) => {
  const [value, setValue] = useState('');
  const [files, setFiles] = useState([]);
  const fileRef = useRef(null);

  const submit = (event) => {
    event.preventDefault();
    const text = value.trim();
    if ((!text && files.length === 0) || disabled) return;
    setValue('');
    setFiles([]);
    if (fileRef.current) fileRef.current.value = '';
    onSend(text, { files, projectId });
  };

  const removeFile = (index) => {
    setFiles((current) => current.filter((_, itemIndex) => itemIndex !== index));
  };

  return (
    <Form className="chat-input" onSubmit={submit}>
      {files.length > 0 && (
        <div className="chat-file-chips">
          {files.map((file, index) => (
            <button
              type="button"
              key={`${file.name}-${index}`}
              className="chat-file-chip"
              onClick={() => removeFile(index)}
              title="Remove file"
            >
              {file.name}
              <span aria-hidden="true">×</span>
            </button>
          ))}
        </div>
      )}
      <Form.Control
        as="textarea"
        rows={2}
        value={value}
        disabled={disabled}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !event.shiftKey) submit(event);
        }}
        placeholder={placeholder}
      />
      <div className="chat-input-toolbar">
        <input
          ref={fileRef}
          type="file"
          multiple
          hidden
          onChange={(event) => {
            const next = Array.from(event.target.files || []);
            setFiles((current) => [...current, ...next].slice(0, 8));
          }}
        />
        <button
          type="button"
          className="chat-icon-button"
          disabled={disabled}
          onClick={() => fileRef.current?.click()}
          aria-label="Attach files"
          title="Attach files"
        >
          <i className="bi bi-paperclip" />
        </button>
        {projects.length > 0 && (
          <select
            className="chat-project-select"
            value={projectId || ''}
            disabled={disabled}
            onChange={(event) => onProjectChange?.(event.target.value || '')}
          >
            <option value="">Select a project</option>
            {projects.map((project) => (
              <option key={project.id} value={project.id}>
                {project.name}
              </option>
            ))}
          </select>
        )}
        <button
          type="submit"
          className="chat-send-button"
          disabled={disabled || (!value.trim() && files.length === 0)}
          aria-label="Send"
        >
          <i className="bi bi-arrow-up" />
        </button>
      </div>
    </Form>
  );
};

export default ChatInput;
